import {
  addClerkPrefix,
  getClerkJsMajorVersionOrTag,
  getScriptUrl,
  parseSearchParams,
  stripScheme
} from "./chunk-LGCO7KY3.mjs";
import "./chunk-NDCDZYN6.mjs";
export {
  addClerkPrefix,
  getClerkJsMajorVersionOrTag,
  getScriptUrl,
  parseSearchParams,
  stripScheme
};
//# sourceMappingURL=url.mjs.map